'use client';
import { LogParams, postLog } from '~/apis/log';
import { getAppLogContext } from '~/services/app-interface';

const defaultParams = {
  event_source: 'bunjang-app' as const,
  event_time: new Date(),
  language: globalThis.window?.navigator?.language,
  ref_url: globalThis.window?.document?.referrer,
  url: globalThis.window?.location?.href,
  // 웹뷰 전용 프로젝트라 아래 정보는 app log context에 있으므로 따로 넣지 않음
  // buid: getBuid(),
  // session_id: getSessionId(),
  // device_type: isMobile ? 'm' : 'w',
};



export const sendLog = (params: LogParams) => {
  const appLogContext = getAppLogContext();

  return postLog({
    ...defaultParams,
    ...appLogContext,
    ...params,
  });
};
